import { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { FiArrowUpRight } from "react-icons/fi"; // icon thay cho fa-regular fa-arrow-up-right

import { projectsData as detailedProjects } from "../../data/projectsData"; // import data chi tiết

const projectsData = detailedProjects.map((project, index) => ({
  id: index + 1,
  categories: project.categories,
  title: project.title,
  image: project.mainImage, // dùng hoverImg nếu có
  slug: project.slug,
  delay: index % 2 === 0 ? ".3s" : ".5s", // giữ delay xen kẽ
}));

const ProjectSection = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const projectsPerPage = 2; // mỗi trang 2 project
  const totalPages = Math.ceil(projectsData.length / projectsPerPage);

  const indexOfLast = currentPage * projectsPerPage;
  const indexOfFirst = indexOfLast - projectsPerPage;
  const currentProjects = projectsData.slice(indexOfFirst, indexOfLast);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <section className="portfolio-section fix section-padding">
      <div className="container">
        <div className="row g-4">
          {currentProjects.map((project) => (
            <div
              key={project.id}
              className="col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={project.delay}
            >
              <div className="portfolio-card-items mt-0">
                <div className="content">
                  <div className="title-header">
                    <span>{project.categories}</span>
                    <h3>
                      <Link to={`/du-an/${project.slug}`}>{project.title}</Link>
                    </h3>
                  </div>
                  <Link
                    to={`/du-an/${project.slug}`}
                    className="icon"
                  >
                    <FiArrowUpRight />
                  </Link>
                </div>
                <div className="thumb">
                  <img
                    src={project.image}
                    alt="img"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div
          className="page-nav-wrap pt-5 text-center wow fadeInUp"
          data-wow-delay=".3s"
        >
          <ul>
            <li>
              <button
                className="page-numbers icon"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <FaArrowLeft />
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i}>
                <button
                  className={`page-numbers ${
                    currentPage === i + 1 ? "current" : ""
                  }`}
                  onClick={() => goToPage(i + 1)}
                >
                  {String(i + 1).padStart(2, "0")}
                </button>
              </li>
            ))}
            <li>
              <button
                className="page-numbers icon"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <FaArrowRight />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
